import { useEffect, useState } from "react";
import "./delete_my_account.css";
import { ReactComponent as LoadingIcon } from "../../icons/loading.svg";
// import { FaAngleLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import CountryDropdown from "../../components/country_dropdown/countryDropdown";
import axios from "axios";
// import tickAnimation from "../../components/tink_animation.json";
import {
  delete_account_otp_url,
  delete_account_resend_otp_url,
  delete_account_url,
} from "../../api/urls";
import OTPInput from "react-otp-input";
import { ArrowLeft, CheckCircle } from "lucide-react";
// import { OTPInput } from "../otp/otpInput";
import Logo from "../../Assests/logo.png"
import Image from "../../components/Image";
const country_api = "/masters/country/";

const DeleteMyAccount = () => {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});
  const [countries, setCoutries] = useState();
  const [token, setToken] = useState();
  const [selectedCountry, setSelectedCountry] = useState(
    countries?.[countries?.length - 1],
  );
  useEffect(() => {
    try {
      axios
        .get(process.env.REACT_APP_API + country_api)
        .then((res) => {
          setCoutries(res.data);
          setSelectedCountry(res.data?.[res.data?.length - 1]);
        })
        .catch((e) => {
          unknownError();
        });
    } catch {
      unknownError();
    }
  }, []);

  const set = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  if (!countries) {
    return (
      <div className="delete-my-account-page">
        <LoadingIcon height={100} width={100} />
      </div>
    );
  }

  return (
    <div className="delete-my-account-page">
      {step === 0 && (
        <TakeNumber
          data={data}
          set={set}
          next={() => setStep(1)}
          countries={countries}
          token={token}
          setToken={setToken}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
        />
      )}
      {step === 1 && (
        <TakeOtp
          data={data}
          prev={() => setStep(0)}
          next={() => setStep(2)}
          token={token}
          setToken={setToken}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
        />
      )}
      {step === 2 && <Success />}
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        theme="light"
      /> */}
    </div>
  );
};

const TakeNumber = ({
  next,
  data,
  set,
  countries,
  token,
  setToken,
  selectedCountry,
  setSelectedCountry,
}) => {
  const [saving, setSaving] = useState(false);
  return (
    <form
      className="d-page border rounded-xl"
      onSubmit={(e) => {
        e.preventDefault();
        if (
          selectedCountry?.country_regex &&
          !RegExp(selectedCountry.country_regex).test(
            selectedCountry.country_mobile_code.toString() + data.number,
          )
        ) {
          toast.error("Invalid mobile number");
          return;
        }
        setSaving(true);
        try {
          axios
            .post(process.env.REACT_APP_API + delete_account_otp_url, {
              country_code: selectedCountry.country_mobile_code,
              mobile_number:
                selectedCountry.country_mobile_code.toString() + data.number,
            })
            .then((res) => {
              setToken(res.data.token);
              next();
              setSaving(false);
            })
            .catch((e) => {
              if (e?.response?.data?.data) {
                toast.error(e.response.data.data);
              } else {
                unknownError();
              }
              setSaving(false);
            });
        } catch {
          unknownError();
          setSaving(false);
        }
      }}
    >
      {/* <h1 className="text-xl mb-2 text-center">Account Deletion Request</h1> */}

      <div className="flex justify-center my-5">
        <Image src={Logo} alt="Logo" className={"w-[180px]"} />
      </div>
      <div className="d-title text-center">Enter your mobile number</div>
      <div style={{ padding: "5px" }} />
      <div className="d-description text-sm text-center">
        To deactivate your account, please provide your mobile number.
      </div>
      <div style={{ padding: "15px" }} />
      <div style={{ display: "flex", gap: "10px" }} className="border">
        <CountryDropdown
          countries={countries}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
        />
        <input
          placeholder="Mobile number"
          value={data.nubmer}
          onChange={(e) => set("number", e.target.value)}
          required
          disabled={saving}
        />
      </div>
      <div style={{ padding: "15px" }} />
      <button
        className="submit-btn bg-black text-white hover:bg-slate-200 hover:text-black transition-all"
        disabled={saving}
      >
        Generate OTP
      </button>
    </form>
  );
};

const TakeOtp = ({ data, prev, token, setToken, selectedCountry, next }) => {
  const [saving, setSaving] = useState(false);
  const [otp, setOtp] = useState("");

  return (
    <form
      className="d-page border rounded-xl"
      onSubmit={(e) => {
        e.preventDefault();
        setSaving(true);
        try {
          axios
            .post(
              process.env.REACT_APP_API + delete_account_url,
              // process.env.REACT_APP_API + "/web/del-acc",
              {
                otp: otp,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Token: token,
                },
              },
            )
            .then((res) => {
              next();
              setSaving(false);
            })
            .catch((e) => {
              if (e?.response?.data?.data) {
                toast.error(e.response.data.data);
              } else {
                unknownError();
              }
              setSaving(false);
            });
        } catch {
          unknownError();
          setSaving(false);
        }
      }}
    >
      <div onClick={() => prev()} className="p-2 bg-gray-100 rounded-xl w-fit">
        <ArrowLeft className="back-icon" />
      </div>
      <div className="flex justify-center my-5">
        <Image src={Logo} alt="Logo" className={"w-[180px]"} />
      </div>
      <div className="d-title">Enter provided OTP</div>
      <div style={{ padding: "5px" }} />
      <div className="d-description">
        An otp has been send to your mobile number {data.number}.
      </div>
      <div style={{ padding: "15px" }} />
      <OTPInput
        containerStyle="otps"
        value={otp}
        onChange={(v) => {
          setOtp(v);
        }}
        numInputs={6}
        inputStyle="otp"
        skipDefaultStyles
        inputType="number"
        renderInput={(props) => {
          return <input {...props} style={{ border: "1px solid gray" }} />;
        }}
      />
      <div style={{ padding: "15px" }} />
      <div style={{ display: "flex", gap: "10px" }}>
        <ResendButton
          setToken={setToken}
          token={token}
          data={data}
          selectedCountry={selectedCountry}
        />
        <button className="submit-btn bg-black text-white" style={{ flex: 1 }} disabled={saving}>
          Submit OTP
        </button>
      </div>
    </form>
  );
};

const Success = () => {
  //   const defaultOptions = {
  //     loop: false,
  //     autoplay: true,
  //     animationData: tickAnimation,
  //   };
  return (
    <div className="d-page border rounded-xl min-h-[300px]">
      <div className="flex justify-center"
      // style={{
      //   margin: "auto",
      //   marginTop: "-60px",
      //   marginBottom: "-60px",
      //   zIndex: -1,
      // }}
      >
        {/* <Lottie options={defaultOptions} height={300} width={300} /> */}
        <CheckCircle size={60} className="text-green-700" />
      </div>
      <center>
        <div className="d-title">Request Submitted Successfully !</div>
      </center>
      <div style={{ padding: "5px" }} />
      <center>
        <div className="d-description text-sm">
          Account delete request submitted successfully. Your account would be
          deleted within 30 days.
        </div>
      </center>
    </div>
  );
};

const ResendButton = ({ data, setToken, selectedCountry, token }) => {
  const [seconds, setSeconds] = useState(30);
  useEffect(() => {
    const remove = setTimeout(() => {
      if (seconds > 0) {
        setSeconds((prev) => prev - 1);
      } else {
        clearTimeout(remove);
      }
    }, 1000);
    return () => {
      clearTimeout(remove);
    };
  }, [seconds]);

  const resendOTP = () => {
    try {
      axios
        .post(
          process.env.REACT_APP_API + delete_account_resend_otp_url,
          {
            country_code: selectedCountry.country_mobile_code,
            mobile_number:
              selectedCountry.country_mobile_code.toString() + data.number,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Token: token,
            },
          },
        )
        .then((res) => {
          setToken(res.data.token);
          setSeconds(30);
        })
        .catch((e) => {
          if (e?.response?.data?.data) {
            toast.error(e.response.data.data);
          } else {
            unknownError();
          }
        });
    } catch {
      unknownError();
    }
  };
  return (
    <button
      type="button"
      className="submit-btn"
      disabled={seconds > 0}
      onClick={() => resendOTP()}
      style={{ flex: 1 }}
    >
      {seconds === 0 ? "Resend OTP" : `${seconds}s`}
    </button>
  );
};

const unknownError = () => {
  toast.error("Something went wrong.");
};

export default DeleteMyAccount;
